/*
 * Author: Harper Yan
 * File Created: Tuesday, 24-07-16 03:59 pm
 * Last Modified: Wednesday, 24-08-14 06:17 pm, by Harper Yan
 */

import {
  ComponentsOverrides,
  ComponentsProps,
  ComponentsVariants,
  Theme,
} from '@mui/material/styles';
import { TypographyOptions } from '@mui/material/styles/createTypography';

type TypographyThemeOptions = {
  defaultProps?: ComponentsProps['MuiTypography'];
  styleOverrides?: ComponentsOverrides<Theme>['MuiTypography'];
  variants?: ComponentsVariants<Theme>['MuiTypography'];
};

export const MuiTypography: TypographyThemeOptions = {
  styleOverrides: {
    root: ({ theme }) => ({
      '&:lang(en)': {
        fontFamily: 'Inter, sans-serif',
      },
      '&:lang(zh)': {
        fontFamily: 'PingFang SC, sans-serif',
      },
    }),
    h6: ({ theme }) => ({
      fontWeight: 700,
    }),
    body1: () => ({
      fontSize: '14px',
      fontWeight: 500,
      lineHeight: 'normal',
    }),
  },
};
